







































import { defineComponent, PropType } from '@nuxtjs/composition-api'
import SectionBasic from '@/components/SectionBasic.vue'
import { sectionCoreProps } from '@/mixins/sectionCore'
import CardAdvantage from '@/components/Cards/CardAdvantage.vue'

type Advantage = {
  id: string
  subtitle: string
  text: string
  background: string
  radius: string
  image: string
}

export default defineComponent({
  name: 'SectionCardsAdvantages',
  components: { CardAdvantage, SectionBasic },
  mixins: [sectionCoreProps],
  props: {
    advantages: {
      type: Array as PropType<Advantage[]>,
      default: () => [],
    },
    advantageImage: {
      type: Object as PropType<Advantage>,
      default: null,
    },
  },
})
